module.exports = __webpack_public_path__ + "img/declaration.d915029b.png";